// The taste app's service worker registration, shared between application.js
// (which registers it once the page loads) and the reload-prompt controller
// (which watches the registration for a new version). Registering twice is
// harmless, but sharing one promise keeps a single listener chain.
const SCRIPT_PATH = "/taste/service-worker"
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000

let registration = null
let lastUpdateCheck = 0

export function serviceWorkerSupported() {
  return "serviceWorker" in navigator
}

export function registerServiceWorker() {
  if (!serviceWorkerSupported()) return Promise.resolve(null)

  registration ||= navigator.serviceWorker
    .register(SCRIPT_PATH, { scope: "/taste/" })
    .then((reg) => { lastUpdateCheck = Date.now(); return reg })
    .catch((error) => {
      console.warn("Service worker registration failed", error)
      return null
    })

  return registration
}

// Browsers only look for a new worker on a full page load. A Turbo session
// can run for hours without one, so ask once an hour on navigation.
export function checkForUpdate(reg) {
  if (!reg || Date.now() - lastUpdateCheck < UPDATE_CHECK_INTERVAL_MS) return
  lastUpdateCheck = Date.now()
  reg.update().catch(() => {})
}
